export const saveStreamCSV = (filename: string, rawText: string): void => {
  // Prepend BOM to make Excel happy
  const text = `\ufeff${rawText}`;
  const anchor = document.createElement('a');
  anchor.download = filename;
  const blobObject = new Blob([text], { type: 'text/csv' });
  anchor.href = window.URL.createObjectURL(blobObject);
  if (document.createEvent) {
    const event = document.createEvent('MouseEvents');
    event.initEvent('click', true, true);
    anchor.dispatchEvent(event);
  } else {
    anchor.click();
  }
};

/**
 * Builds the login redirect URL that preserves the user's current location
 * so they are returned there after re-authenticating.
 */
export const buildLoginRedirectUrl = (
  pathname = window.location.pathname,
  search = window.location.search,
): string =>
  `/login?errorMessage=Session timed out.  Please log in.&sourcePath=${encodeURIComponent(
    pathname + search,
  )}`;

export const forceSignOut = (): void => {
  window.location.href = buildLoginRedirectUrl();
};
